import { Container, Row, Col, Card } from "react-bootstrap";
import { FaLinkedinIn } from "react-icons/fa";
import "../../styles/MentorShip.css";

const mentors = [
  {
    name: "Sarah Chen",
    role: "Founder & Lead Mentor",
    desc: "Former Principal Engineer at Google with 15+ years empowering women in tech.",
    image: "/assets/mentors/mentor1.png",
    linkedin: "https://www.linkedin.com/in/sarahchen",
  },
  {
    name: "Maya Patel",
    role: "Senior Engineering Mentor",
    desc: "Staff Engineer specializing in distributed systems and career advancement.",
    image: "/assets/mentors/mentor2.png",
    linkedin: "https://www.linkedin.com/in/mayapatel",
  },
  {
    name: "Jennifer Rodriguez",
    role: "Career Coach",
    desc: "Helping engineers navigate promotions and leadership transitions.",
    image: "/assets/mentors/mentor3.png",
    linkedin: "https://www.linkedin.com/in/jenniferrodriguez",
  },
  {
    name: "Amara Okafor",
    role: "Technical Mentor",
    desc: "Full-stack engineer passionate about inclusive engineering cultures.",
    image: "/assets/mentors/mentor4.png",
    linkedin: "https://www.linkedin.com/in/amaraokafor",
  },
];

const MentorsSection = () => {
  return (
    <section className="mentors-section bg-black text-white py-5">
      <Container>
        <h2 className="mentors-heading wise-secondary-gradient fw-bold mb-4">
          Meet Our Mentors
        </h2>

        <Row>
          {mentors.map((mentor, index) => (
            <Col md={3} sm={6} key={index} className="mb-4">
              <Card className="mentor-profile-card bg-title h-100 border-0">
                {/* Image */}
                <div className="mentor-img-wrapper">
                  <Card.Img
                    variant="top"
                    src={mentor.image}
                    alt={mentor.name}
                    className="mentor-img"
                  />
                </div>

                {/* Content */}
                <Card.Body className="mentor-card-body">
                  {/* Name row */}
                  <div className="mentor-name-row">
                    <Card.Title className="text-secondary mentor-name mb-0">
                      {mentor.name}
                    </Card.Title>

                    <a
                      href={mentor.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mentor-linkedin-inline"
                      aria-label={`${mentor.name} LinkedIn`}
                    >
                      <FaLinkedinIn />
                    </a>
                  </div>

                  <small className="text-secondary mentor-role">
                    {mentor.role}
                  </small>

                  <Card.Text className="text-secondary mentor-desc mt-2">
                    {mentor.desc}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default MentorsSection;
